import { UPDATE_EXPERIMENTS } from '../actions/experimentActions';

const initExperimentState = {
  mobileDownload: {
    variation: 'A',
    message:
      'Download the BuyPower Mobile App to enjoy more in-app features like Meter Consumption History, Borrow-to-pay, etc',
    executed: false,
  },
};

export default (state = initExperimentState, action) => {
  switch (action.type) {
    case UPDATE_EXPERIMENTS:
      return { ...state, ...action.data };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/experimentReducer.js